import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsService } from '../../services/forms.service';
import { EventService } from '../../services/event.service';
import * as _ from 'lodash';

import { FormGroup, FormControl, FormArray, AbstractControl, NgControlStatus } from '@angular/forms';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { LoadingIndicatorService } from '../../services/loading-indicator.service';
import { warning, error as exception } from 'toastr';
import 'rxjs/add/observable/forkJoin';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Registration, IKvKSearchResult } from '../../interfaces';
import { MultiSelectElement } from '../../models/multi-select-element';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.less']
})
export class RegistrationComponent implements OnInit {
  public dialogVisible = false;
  public doneLoading = false;

  public eventName: string;
  public eventDescription: string;
  public eventStart: Date;
  public eventEnd: Date;
  public dateFormat: string;
  public eventKey = '';
  public emailAddress = '';
  public formNotFound = false;

  // formulier gerenderd
  public formData: Registration.Form.IForm;
  // initiele waarden
  private initialFormData: Registration.Form.IForm;

  // resultaat service
  public registrationForm: Registration.Form.IForm;
  public registrationFormRegistrar: Registration.Form.IForm;

  public register: 'self' | 'other' = 'self';

  constructor(private route: ActivatedRoute,
    private formsService: FormsService,
    private eventService: EventService,
    private translation: TranslateService,
    private loader: LoadingIndicatorService,
    private router: Router) {
    this.route.params.subscribe((p) => {
      this.eventKey = p['eventKey'];
    });

    this.route.queryParams.subscribe((p) => {
      this.emailAddress = p['email'];
    });

    this.translation.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadForm();
      this.dateFormat = event.lang;
    });
  }

  public ngOnInit() {
    this.loadForm();
  }

  public hasChanges() {
    return _.isEqual(this.formData, this.initialFormData);
  }

  public onKvkSearch(value: IKvKSearchResult) {

    this.setValue('data-iskvk-company', value.organisation);
    this.setValue('data-iskvk-address', value.address);
    this.setValue('data-iskvk-postalcode', value.postalCode);
    this.setValue('data-iskvk-city', value.city);
    this.setValue('data-iskvk-country', value.country);
  }

  public onCaribbeanChange(value: boolean) {
    this.setEditable('data-iskvk-company', value);
    this.setEditable('data-iskvk-address', value);
    this.setEditable('data-iskvk-postalcode', value);
    this.setEditable('data-iskvk-city', value);
    this.setEditable('data-iskvk-country', value);
    if (value) {
      this.setValue('data-iskvk-company', null);
      this.setValue('data-iskvk-address', null);
      this.setValue('data-iskvk-postalcode', null);
      this.setValue('data-iskvk-city', null);
      this.setValue('data-iskvk-country', null);
    }
  }

  private setValue(name: string, value: string): void {
    const control = this.findControlByAttributeName(name);
    control.control.setValue(value);
  }

  private setEditable(name: string, editable: boolean): void {
    const control = this.findControlByAttributeName(name);
    if (control === null) {
      return;
    }

    control.control.disable();
    if (editable) {
      control.control.enable();
    } else {
      control.control.disable();
    }
  }

  public onNextSection(): void {
    if (this.canNextSection()) {
      const step = this.currentSection();
      this.validateAllFormFields(step.form);
      if (!step.form.valid) {
        console.log('Step not valid');
        return;
      }
      const index = this.formData.steps.indexOf(step);
      step.visible = false;
      this.formData.steps[index + 1].visible = true;
    }
  }

  public canNextSection(): boolean {
    const index = this.formData.steps.indexOf(this.currentSection());
    return index < this.formData.steps.length - 1;
  }

  public onPreviousSection(): void {
    if (this.canPreviousSection()) {
      const step = this.currentSection();
      const index = this.formData.steps.indexOf(step);
      step.visible = false;
      this.formData.steps[index - 1].visible = true;
    }
  }

  public canPreviousSection(): boolean {
    const index = this.formData.steps.indexOf(this.currentSection());
    return index > 0;
  }

  public isLastPage(): boolean {
    const index = this.formData.steps.indexOf(this.currentSection());
    return index === this.formData.steps.length - 1;
  }

  private currentSection(): Registration.Form.IStep {
    let step: Registration.Form.IStep;
    this.formData.steps.forEach((item) => {
      if (item.visible) {
        step = item;
      }
    });

    return step;
  }

  private validateAllFormFields(control: AbstractControl) {
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach((field: string) => {
        const groupControl = control.get(field);
        this.validateAllFormFields(groupControl);
      });
    } else if (control instanceof FormArray) {
      const controlAsFormArray = control as FormArray;
      controlAsFormArray.controls.forEach((arrayControl: AbstractControl) => this.validateAllFormFields(arrayControl));
    }
  }

  public onRegistrarChange(): void {
    const copyData = _.cloneDeep(this.formData);
    this.setData(this.registrationForm, this.registrationFormRegistrar, copyData, this.register === 'other');
  }

  private setData(registrationForm: Registration.Form.IForm,
    registrationFormRegistrar: Registration.Form.IForm,
    copyData: Registration.Form.IForm,
    registrar: boolean) {

    this.formData = _.cloneDeep(registrationForm);

    if (registrar) {
      // todo dit moet beter
      this.formData.steps[0].sections.unshift(_.cloneDeep(registrationFormRegistrar.steps[0].sections[0]));
    }

    this.GenerateFormControlsForModel(this.formData);
    this.setControlValue(this.emailAddress, this.register);
    this.copyValues(this.formData, copyData);
    this.initialFormData = _.cloneDeep(registrationForm);
  }

  public getElementType(element: Registration.Form.IElement): string {
    if (element.inputType === 'text') {

      // kvk control
      const found = _.find(element.attributes, (attribute) => {
        return attribute.name === 'data-iskvk-number';
      });

      if (found) {
        return 'kvkSearch';
      }
    }

    return element.inputType;
  }

  private loadForm(): void {
    this.loader.StartWork();

    // keep copy of current data. This is needed when switching between languages
    const copyData = _.cloneDeep(this.formData);
    this.formData = null;
    this.formNotFound = false;

    forkJoin(
      this.formsService.GetRegistrationForm(this.eventKey, this.translation.currentLang),
      this.formsService.GetRegistrationFormRegistrar(this.eventKey, this.translation.currentLang),
      this.eventService.get(this.eventKey))
      .subscribe(([registrationForm, registrationFormRegistrar, event]) => {
        if (registrationForm === null) {
          this.formNotFound = true;
          return;
        }

        if (new Date(event.registrationStartDate) > new Date(Date.now()) || new Date(event.registrationEndDate) < new Date(Date.now())) {
          this.router.navigate(['/error-page/event-closed']);
        }

        // event info
        this.eventName = event.name;
        this.eventDescription = event.description;
        this.eventStart = event.eventStartDate;
        this.eventEnd = event.eventEndDate;
        this.dateFormat = this.translation.currentLang;

        // generate controls
        this.registrationForm = registrationForm;
        this.registrationFormRegistrar = registrationFormRegistrar;

        this.setData(registrationForm, registrationFormRegistrar, copyData, this.register === 'other');

        this.onCaribbeanChange(false);
      },
        error => {
          if (error.status === 400) {
            exception(error.error);
          } else {
            this.translation.get('app-commonerror.api-get').toPromise().then((result) => {
              exception(result);
            });
          }
          this.loader.EndWork();
        },
        () => {
          this.doneLoading = true;
          this.loader.EndWork();
        });
  }

  /** Copy the user input into the new form */
  public copyValues(newData: Registration.Form.IForm, oldData: Registration.Form.IForm): void {
    if (newData === null || newData === undefined || oldData === null || oldData === undefined) {
      return;
    }

    _.each(newData.steps, (step) => {
      _.each(step.sections, (section) => {
        _.each(section.elements, (element) => {
          const oldElement = this.findControlById(oldData, element.inputKey);
          if (oldElement) {
            element.control.setValue(oldElement.control.value);
            element.value = oldElement.control.value;
          }
        });
      });
    });
  }

  public onCopyAddress(values: Registration.Form.ICopyItem): void {
    // find all target questions and hide them
    _.each(values.values, (value) => {
      var target: Registration.Form.IElement = this.findControlById(this.formData, value.Target);
      target.hidden = !values.on;
    });
  }

  public onSubmit() {
    const section = this.currentSection();
    if (section.form.invalid) {
      // return;
    }

    if (this.isLastPage()) {
      this.submitData();
    } else {
      this.onNextSection();
    }
  }

  private getAttribute(element: Registration.Form.IElement, name: string): string {
    let result;
    element.attributes.forEach((item) => {
      if (item.name === name) {
        result = item.value;
      }
    });

    return result;
  }

  private copyAddress(form: Registration.Form.IForm): void {
    // find control with copy address checked
    var element = this.findControlByAttributeName('copyAddress');
    if (element && element.value === true) {
      const attr = this.getAttribute(element, 'copyAddress');
      const values: Registration.Form.ICopyItem = {
        on: true,
        values: JSON.parse(attr)
      };

      // find all target questions and hide them
      _.each(values.values, (value) => {
        var target: Registration.Form.IElement = this.findControlById(this.formData, value.Target);
        var source: Registration.Form.IElement = this.findControlById(this.formData, value.Source);
        target.control.setValue(source.control.value);
      });
    }
  }

  private submitData(): void {
    this.loader.StartWork();
    const form: Registration.Form.IValues = {
      id: this.formData.key,
      languageCode: this.formData.languageCode,
      partialSave: false,
      emailAddress: this.emailAddress,
      values: [],
      eventKey: this.eventKey
    };

    form.values.push({
      name: 'registerFor',
      value: this.register,
      uiValid: true
    });

    this.copyAddress(this.formData);
    for (const step of this.formData.steps) {
      for (const section of step.sections) {
        for (const element of section.elements) {
          if (element.inputType === 'multiselect') {
            let value: any;
            const multicontrol = <MultiSelectElement>element;
            const values: string[] = [];
            _.each(multicontrol.controls, (item) => {
              const index = multicontrol.controls.indexOf(item);
              if (item.value === true) {
                values.push(multicontrol.options[index].value);
              }
            });
            value = values.join(',');
            form.values.push({
              name: element.inputKey,
              value: value,
              uiValid: true
            });
          } else {
            const control = element.control;
            let value: any;
            if (element.inputType === 'url') {
              if (control.value && control.value.indexOf('://') === -1) {
                value = `http://${control.value}`;
              } else {
                value = control.value;
              }
            } else {
              value = control.value;
            }

            form.values.push({
              name: element.inputKey,
              value: value,
              uiValid: control.valid
            });
          }
        }
      }
      }
      
    this.formsService.SubmitRegistrationForm(this.eventKey, form).toPromise()
      .then((response) => {
          this.loader.EndWork();
          const str = JSON.stringify(response);
          console.log(str);
          console.log('Klaar' + response);
          console.log('Klaar' + response.success);

        if (response.success) {
          // Redirect to thankyou page
          this.router.navigate([`/${this.eventKey}/thankyou`]);
        } else {
          // todo give feedback
          response.messages.forEach((value) => {
            const control = this.findControlById(this.formData, value.field);
            if (control) {
              // todo verbeteren > ergens bij het control of als melding onderin of als toast?
              warning(`Field ${control.title}: ${value.message}`);
              control.control.setErrors({ 'server': value.message });
            }
          });
          this.translation.get('register.server-validation-error').toPromise().then((value) => {
            exception(value);
          });
        }
      })
      .catch(() => {
        this.loader.EndWork();
        this.translation.get('app-commonerror.api-get').toPromise().then((result) => {
          exception(result);
        });
      });
  }

  private setControlValue(value: string, type: string): void {
    const emailControl = this.findControlByAttribute('data-isemail', type === 'self' ? 'participant' : 'on-behalf-of');
    if (emailControl !== null) {
      emailControl.value = value;
      emailControl.control.setValue(value);
    }
  }

  private findControlById(form: Registration.Form.IForm, id: string): Registration.Form.IElement {
    for (const step of form.steps) {
      for (const section of step.sections) {
        for (const element of section.elements) {
          if (element.inputKey === id) {
            return element;
          }
        }
      }
    }

    return null;
  }

  private findControlByAttribute(name: string, value: string): Registration.Form.IElement {
    for (const step of this.formData.steps) {
      for (const section of step.sections) {
        for (const element of section.elements) {
          for (const attribute of element.attributes) {
            if (attribute.name === name && value === value) {
              return element;
            }
          }
        }
      }
    }

    return null;
  }

  private findControlByAttributeName(name: string): Registration.Form.IElement {
    for (const step of this.formData.steps) {
      for (const section of step.sections) {
        for (const element of section.elements) {
          for (const attribute of element.attributes) {
            if (attribute.name === name) {
              return element;
            }
          }
        }
      }
    }

    return null;
  }

  private GenerateFormControlsForModel(formModel: Registration.Form.IForm): void {
    for (const step of formModel.steps) {
      const controls = {};
      step.visible = formModel.steps.indexOf(step) === 0;
      for (const section of step.sections) {
        for (const element of section.elements) {
          let control: FormControl;
          switch (element.inputType) {
            case 'multiselect':
              const index = section.elements.indexOf(element);
              const multiElement = new MultiSelectElement(element);
              multiElement.control = this.formsService.CreateFromControl(element);
              _.each(element.options, (option) => {
                const optionIndex = element.options.indexOf(option);
                const control = new FormControl(multiElement.values[optionIndex].value);
                controls[element.inputKey + optionIndex] = control;
                multiElement.controls.push(control);
              });
              section.elements[index] = multiElement;
              break;
            case 'select':
              control = this.formsService.CreateFromControl(element);
              controls[element.inputKey] = control;
              element.control = control;
              // ie11 hack
              const text = this.translation.instant('registration-form.select-empty');
              element.options.unshift(<any>{ name: text, value: '', disabled: true });
              element.control.setValue('');
              break;
            case 'checkbox':
              control = this.formsService.CreateFromControl(element);
              const value = this.getAttribute(element, 'default_value');
              if (value === 'true') {
                control.setValue('true');
                element.value = 'true';
              }
              controls[element.inputKey] = control;
              element.control = control;
              break;
            default:
              control = this.formsService.CreateFromControl(element);
              controls[element.inputKey] = control;
              element.control = control;
              break;
          }
        }
      }

      step.form = new FormGroup(controls);
    }
  }
}
